import { Component, Input, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-data-viewer-widget',
    templateUrl: './data-viewer-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './data-viewer-widget.component.scss'],
    standalone: false
})
export class DataViewerWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input() path: string = '';
  @Input() fileType: string = '';
  @Input() directPath: string = '';
  @Input() host: string = '';

  public title: string = '';

  ngOnInit(): void {
    this.title = this.path.split('/').pop() || 'Data Viewer';
  }
}
